import Repository from './Repository';

const resource = '/homework';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    update(payload, id) {return Repository.post(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    attachStudent(payload) {return Repository.post(`${resource}/attachments/attachStudent`, payload);},
    attachTeacher(payload) {return Repository.post(`${resource}/attachments/attachTeacher`, payload);},
}